<div *ngIf="isLoaded; else loading" class="cp-onboard-wrapper">
  <div class="modal_title_container" mat-dialog-title>
    <div class="pop_options">
      <ng-container>
        <div
          class="title_box"
          [ngClass]="{active: selectedTab == index}"
          *ngFor="let title of tabList; let index = index"
          (click)="selectTab(index)"
        >
          <div>{{ title }}</div>
        </div>
      </ng-container>
    </div>
    <i class="icon-close" (click)="onClose()"></i>
  </div>

  <div class="graph-inner-container f-1 o-auto" mat-dialog-content>
    <div class="body-container" [ngSwitch]="selectedTab">
      <app-org-account-info
        *ngSwitchCase="0"
        [isNewOrg]="data.mode === 'add'"
        [parentOrgId]="data.parentOrgId"
        [organization]="organization"
        [organizationType]="data.organizationType"
      ></app-org-account-info>
    </div>
  </div>
</div>

<ng-template #loading>
  <skeleton-loader type="modal-1"></skeleton-loader>
</ng-template>
